import { Checkbox } from 'semantic-ui-react';
import { SectionBlock, ToggleRow } from '../serviceFormStyles';

export const FormSection = ({ id, number, title, description, raised = false, children }) => (
  <SectionBlock
    id={id}
    aria-labelledby={`${id}-title`}
    className={raised ? 'is-raised' : undefined}
  >
    <div className="section__header">
      <span className="section__number">{number}</span>
      <div>
        <h2 id={`${id}-title`}>{title}</h2>
        {description && <p className="section__description">{description}</p>}
      </div>
    </div>
    {children}
  </SectionBlock>
);

export const ToggleField = ({ name, label, checked, onChange, hint, children }) => (
  <ToggleRow>
    <Checkbox
      toggle
      id={name}
      name={name}
      label={label}
      checked={Boolean(checked)}
      onChange={onChange}
    />
    {checked && hint && <p className="toggle__hint">{hint}</p>}
    {checked && children && <div className="toggle__body">{children}</div>}
  </ToggleRow>
);
